/* verni — theme.js */
(function () {
  'use strict';

  const qs  = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ========== Drawers ========== */
  const drawerOverlay = qs('[data-drawer-overlay]');

  function openDrawer(id) {
    const drawer = qs('[data-drawer="' + id + '"]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    if (drawerOverlay) {
      drawerOverlay.classList.add('is-open');
      drawerOverlay.removeAttribute('hidden');
    }
    document.body.style.overflow = 'hidden';
    const focusable = drawer.querySelector('input, button, a');
    if (focusable) focusable.focus();
  }

  function closeDrawer(drawer) {
    const target = typeof drawer === 'string' ? qs('[data-drawer="' + drawer + '"]') : drawer;
    if (target) target.classList.remove('is-open');
    qsa('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer();
    }
  });

  if (drawerOverlay) drawerOverlay.addEventListener('click', () => closeDrawer());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ========== Announcement Bar ========== */
  /* Always visible — clear any legacy dismissed flag */
  try { localStorage.removeItem('verni:announcement-dismissed'); } catch (_) {}
  const announceBar = qs('[data-announcement-bar]');
  if (!announceBar) {
    document.body.classList.add('announcement-hidden');
  }

  /* ========== Mega menu open/close state ========== */
  const megaOverlay = qs('[data-mega-overlay]');
  const megaDropdown = qs('.dropdown--mega');
  if (megaDropdown && megaOverlay) {
    function openMega() {
      document.body.classList.add('mega-menu-open');
      megaOverlay.classList.add('is-visible');
    }
    function closeMega() {
      document.body.classList.remove('mega-menu-open');
      megaOverlay.classList.remove('is-visible');
    }
    megaDropdown.addEventListener('mouseenter', openMega);
    megaDropdown.addEventListener('mouseleave', closeMega);
    megaDropdown.addEventListener('focusin', openMega);
    megaDropdown.addEventListener('focusout', (e) => {
      if (!megaDropdown.contains(e.relatedTarget)) closeMega();
    });
    megaOverlay.addEventListener('click', closeMega);
  }

  /* ========== Header scroll state (homepage) ========== */
  const header = qs('[data-header]');
  if (header && document.body.classList.contains('template-index')) {
    const hero = qs('.hero');
    if (hero) {
      function updateHeaderState() {
        const heroBottom = hero.getBoundingClientRect().height;
        const scrollY = window.scrollY || window.pageYOffset;
        /* switch to dark header once we scroll past ~80% of the hero */
        if (scrollY > heroBottom * 0.8) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
      }
      window.addEventListener('scroll', updateHeaderState, { passive: true });
      updateHeaderState();
    }
  }

  /* ========== Accordion ==========
     Only one accordion in a group can be open at a time. Opening any
     product-info accordion also auto-closes the inline size chart.     */
  qsa('[data-accordion]').forEach(acc => {
    const toggle = qs('[data-accordion-toggle]', acc);
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const opening = !acc.classList.contains('is-open');
      const group = acc.closest('.accordions-row') || document;
      qsa('[data-accordion]', group).forEach(a => {
        a.classList.remove('is-open');
        const t = qs('[data-accordion-toggle]', a);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (opening) {
        acc.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        /* also close the inline size chart if one is open */
        const chart = qs('[data-product-size-chart]');
        if (chart) chart.classList.remove('is-open');
      }
    });
  });

  /* ========== Predictive Search ========== */
  const searchInput = qs('[data-predictive-search-input]');
  const searchResults = qs('[data-predictive-search-results]');
  if (searchInput && searchResults) {
    let debounceId;
    searchInput.addEventListener('input', () => {
      clearTimeout(debounceId);
      const q = searchInput.value.trim();
      if (!q) {
        searchResults.innerHTML = '';
        return;
      }
      debounceId = setTimeout(() => {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
        fetch(url)
          .then(r => r.json())
          .then(data => {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="predictive-search__empty">no results</div>';
              return;
            }
            searchResults.innerHTML = products.map(p => {
              const img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<div></div>';
              return '<a href="' + p.url + '" class="predictive-search__item">' + img +
                '<span>' + p.title + '</span>' +
                '<span>' + (p.price || '') + '</span></a>';
            }).join('');
          })
          .catch(() => {});
      }, 200);
    });
  }

  /* ========== Cart Drawer Refresh ========== */
  async function refreshCart() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await r.json();
      const count = qs('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      const sectionR = await fetch('/?sections=cart-drawer');
      const sections = await sectionR.json();
      if (sections['cart-drawer']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];
        const newDrawer = tmp.querySelector('[data-drawer="cart"]');
        const current = qs('[data-drawer="cart"]');
        if (newDrawer && current) {
          const wasOpen = current.classList.contains('is-open');
          current.innerHTML = newDrawer.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
      }
    } catch (e) {}
  }

  /* ========== Product Card Image Slider ========== */
  const cardMobileMq = window.matchMedia('(max-width: 1023px)');

  /* mobile: swipe changes photo; arrows only appear after first swipe */
  function initCardSwipe() {
    qsa('.product-card__link').forEach(link => {
      if (link.dataset.swipeInit) return;
      link.dataset.swipeInit = '1';
      link.addEventListener('scroll', () => {
        const media = link.closest('[data-card-media]');
        if (media) media.classList.add('has-swiped');
      }, { passive: true, once: true });
    });
  }
  if (document.readyState !== 'loading') initCardSwipe();
  else document.addEventListener('DOMContentLoaded', initCardSwipe);

  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-card-prev]');
    const next = e.target.closest('[data-card-next]');
    if (!prev && !next) return;
    e.preventDefault();
    e.stopPropagation();
    const media = (prev || next).closest('[data-card-media]');
    if (!media) return;
    const slides = qsa('.product-card__slide', media);
    if (slides.length < 2) return;

    /* mobile: arrows scroll the swipe container */
    if (cardMobileMq.matches) {
      const link = media.querySelector('.product-card__link');
      if (link) {
        const w = link.clientWidth;
        const atEnd = link.scrollLeft + w >= link.scrollWidth - 4;
        const atStart = link.scrollLeft <= 4;
        if (next) {
          link.scrollTo({ left: atEnd ? 0 : link.scrollLeft + w, behavior: 'smooth' });
        } else {
          link.scrollTo({ left: atStart ? link.scrollWidth : link.scrollLeft - w, behavior: 'smooth' });
        }
      }
      return;
    }

    const current = media.querySelector('.product-card__slide.is-active');
    const idx = parseInt(current.getAttribute('data-slide-index') || '0', 10);
    let nextIdx;
    if (next) {
      nextIdx = idx + 1 >= slides.length ? 0 : idx + 1;
    } else {
      nextIdx = idx - 1 < 0 ? slides.length - 1 : idx - 1;
    }
    current.classList.remove('is-active');
    slides[nextIdx].classList.add('is-active');
  });

  /* ========== Size Flyout Toggle ========== */
  const isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;

  function openFlyout(flyout) {
    /* close any other open flyouts first */
    qsa('.product-card__size-flyout.is-open').forEach(f => {
      if (f !== flyout) { f.classList.remove('is-open'); f.setAttribute('hidden', ''); }
    });
    flyout.removeAttribute('hidden');
    flyout.offsetHeight; /* reflow for transition */
    flyout.classList.add('is-open');
  }
  function closeFlyout(flyout) {
    flyout.classList.remove('is-open');
    flyout.setAttribute('hidden', '');
  }

  function resetFlyoutSelection(flyout) {
    flyout.classList.remove('has-selected-size');
    flyout.classList.remove('show-size-guide');
    flyout.classList.remove('is-wishlist-mode');
    flyout.removeAttribute('data-selected-variant-id');
    flyout.removeAttribute('data-wishlist-product-id');
    qsa('[data-select-variant]', flyout).forEach(b => {
      b.classList.remove('is-selected');
      // restore disabled state that was stripped for wishlist-mode
      if (b.getAttribute('data-was-disabled') === '1') {
        b.setAttribute('disabled', '');
        b.removeAttribute('data-was-disabled');
      }
    });
    const panel = flyout.querySelector('[data-size-guide-panel]');
    if (panel) panel.setAttribute('hidden', '');
  }

  /* click-based toggle for the + button (desktop and mobile) */
  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('[data-toggle-sizes]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      const media = toggleBtn.closest('[data-card-media]');
      const flyout = media && media.querySelector('[data-size-flyout]');
      if (!flyout) return;
      if (flyout.classList.contains('is-open')) {
        closeFlyout(flyout);
      } else {
        resetFlyoutSelection(flyout);
        openFlyout(flyout);
      }
      return;
    }

    /* close button inside flyout */
    const closeBtn = e.target.closest('[data-flyout-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const flyout = closeBtn.closest('[data-size-flyout]');
      if (flyout) { resetFlyoutSelection(flyout); closeFlyout(flyout); }
      return;
    }

    /* size guide: toggle the inline panel inside the flyout */
    const sizeGuideBtn = e.target.closest('[data-toggle-size-guide]');
    if (sizeGuideBtn) {
      e.preventDefault();
      e.stopPropagation();
      const flyout = sizeGuideBtn.closest('[data-size-flyout]');
      if (!flyout) return;
      flyout.classList.toggle('show-size-guide');
      const panel = flyout.querySelector('[data-size-guide-panel]');
      if (panel) {
        if (flyout.classList.contains('show-size-guide')) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
      return;
    }

    /* close flyout when clicking outside the flyout / + */
    if (!e.target.closest('[data-size-flyout]') && !e.target.closest('[data-toggle-sizes]')) {
      qsa('.product-card__size-flyout.is-open').forEach(f => { resetFlyoutSelection(f); closeFlyout(f); });
    }
  });

  /* ========== Size selection (mark as selected, reveal CTA) ========== */
  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('[data-select-variant]');
    if (!sizeBtn) return;
    const flyout = sizeBtn.closest('[data-size-flyout]');
    if (!flyout) return;
    const isWishlistMode = flyout.classList.contains('is-wishlist-mode');
    const isDisabled = sizeBtn.disabled || sizeBtn.hasAttribute('disabled');
    // block disabled sizes only when adding to cart — wishlist allows sold-out
    if (isDisabled && !isWishlistMode) return;
    e.preventDefault();
    e.stopPropagation();

    // wishlist-mode: clicking a size adds to wishlist instead of revealing CTA
    if (isWishlistMode) {
      const productId = flyout.getAttribute('data-wishlist-product-id');
      const variantId = sizeBtn.getAttribute('data-variant-id');
      const size = sizeBtn.getAttribute('data-variant-title') || sizeBtn.textContent.trim();
      if (productId) {
        wishlistAdd({ id: productId, variantId: variantId, size: size });
        syncWishlistHeart(productId);
        updateWishlistCount();
      }
      flyout.classList.remove('is-wishlist-mode');
      flyout.removeAttribute('data-wishlist-product-id');
      resetFlyoutSelection(flyout);
      closeFlyout(flyout);
      return;
    }

    qsa('[data-select-variant]', flyout).forEach(b => b.classList.remove('is-selected'));
    sizeBtn.classList.add('is-selected');
    flyout.classList.add('has-selected-size');
    flyout.setAttribute('data-selected-variant-id', sizeBtn.getAttribute('data-variant-id'));
  });

  /* ========== Add to bag / Buy now (from flyout CTA) ========== */
  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-flyout-add]');
    const buyBtn = e.target.closest('[data-flyout-buy]');
    if (!addBtn && !buyBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const btn = addBtn || buyBtn;
    const flyout = btn.closest('[data-size-flyout]');
    if (!flyout) return;
    const variantId = flyout.getAttribute('data-selected-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      if (buyBtn) {
        window.location.href = '/checkout';
        return;
      }
      resetFlyoutSelection(flyout);
      closeFlyout(flyout);
      await refreshCart();
      openDrawer('cart');
    } catch (err) {
      /* silent */
    } finally {
      btn.disabled = false;
    }
  });

  /* ========== Product Form AJAX ========== */
  qsa('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      const formData = new FormData(form);
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!r.ok) throw new Error('add failed');
        await refreshCart();
        openDrawer('cart');
      } catch (err) {} finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  /* ========== Cart quantity updates ========== */
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    const key = rm.getAttribute('data-cart-remove');
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshCart();
    } catch (err) {}
  });

  /* ========== Cart cross-sell add ========== */
  document.addEventListener('click', async (e) => {
    const csBtn = e.target.closest('[data-crosssell-add]');
    if (!csBtn) return;
    e.preventDefault();
    const vid = parseInt(csBtn.getAttribute('data-crosssell-add'), 10);
    if (!vid) return;
    csBtn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      });
      if (!r.ok) throw new Error('add failed');
      await refreshCart();
    } catch (err) {} finally {
      csBtn.disabled = false;
    }
  });

  /* ========== Waitlist (notify on restock) ==========
     Submits to the native /contact endpoint so the shop owner receives an email
     with the customer's request. No external integrations required. */
  function submitWaitlist(email, productTitle, size, variantId) {
    const body = 'waitlist request\n' +
                 'product: ' + productTitle + '\n' +
                 (size ? 'size: ' + size + '\n' : '') +
                 (variantId ? 'variant id: ' + variantId + '\n' : '') +
                 'email: ' + email;
    const formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '\u2713');
    formData.append('contact[name]', 'waitlist - ' + email);
    formData.append('contact[email]', email);
    formData.append('contact[subject]', 'waitlist: ' + productTitle + (size ? ' / ' + size : ''));
    formData.append('contact[body]', body);
    return fetch('/contact#contact_form', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'text/html' }
    });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-waitlist-form]');
    if (!form) return;
    e.preventDefault();
    const wrap = form.closest('[data-waitlist]');
    if (!wrap) return;
    const emailInput = form.querySelector('input[type="email"]');
    const msg = form.querySelector('[data-waitlist-msg]');
    const btn = form.querySelector('.waitlist__btn');
    const email = emailInput ? emailInput.value.trim() : '';
    if (!email) return;
    const productTitle = wrap.getAttribute('data-waitlist-product') || '';
    const size = wrap.getAttribute('data-waitlist-size') || '';
    const variantId = wrap.getAttribute('data-waitlist-variant-id') || '';

    if (btn) { btn.disabled = true; btn.textContent = 'a enviar...'; }
    submitWaitlist(email, productTitle, size, variantId)
      .then(() => {
        if (msg) msg.textContent = 'obrigado. avisamos-te por email quando voltar a stock.';
        if (emailInput) emailInput.value = '';
        if (btn) btn.textContent = 'adicionado à waitlist';
        form.classList.add('is-submitted');
      })
      .catch(() => {
        if (msg) msg.textContent = 'erro ao submeter. tenta de novo.';
        if (btn) { btn.disabled = false; btn.textContent = 'join the waitlist'; }
      });
  });

  /* ========== Wishlist helpers ==========
     stored as [{id, variantId, size}, ...] — migrates old ['id', 'id'] format. */
  const WISHLIST_KEY = 'verni:wishlist';
  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      // migrate old string/number format to objects
      return raw.map(item => typeof item === 'object' ? item : { id: String(item), variantId: null, size: null });
    } catch (_) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (_) {}
  }
  function wishlistHas(productId) {
    const id = String(productId);
    return getWishlist().some(it => String(it.id) === id);
  }
  function wishlistAdd(item) {
    const list = getWishlist();
    if (list.some(it => String(it.id) === String(item.id))) return list;
    list.push(item);
    setWishlist(list);
    return list;
  }
  function wishlistRemove(productId) {
    const id = String(productId);
    const list = getWishlist().filter(it => String(it.id) !== id);
    setWishlist(list);
    return list;
  }
  window.verni = window.verni || {};
  window.verni.wishlist = { get: getWishlist, set: setWishlist, has: wishlistHas, add: wishlistAdd, remove: wishlistRemove };

  function updateWishlistCount() {
    const count = getWishlist().length;
    qsa('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function syncWishlistHeart(productId) {
    const active = wishlistHas(productId);
    qsa('[data-wishlist-toggle="' + productId + '"]').forEach(b => {
      b.classList.toggle('is-active', active);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const productId = btn.getAttribute('data-wishlist-toggle');

    // already in wishlist → just remove, no size picker needed
    if (wishlistHas(productId)) {
      wishlistRemove(productId);
      syncWishlistHeart(productId);
      updateWishlistCount();
      return;
    }

    // not in wishlist → find the flyout for this card
    const card = btn.closest('[data-product-card]');
    const media = btn.closest('[data-card-media]') || (card && card.querySelector('[data-card-media]'));
    const flyout = media && media.querySelector('[data-size-flyout]');

    // no flyout / no variants → add directly
    if (!flyout) {
      wishlistAdd({ id: productId, variantId: null, size: null });
      syncWishlistHeart(productId);
      updateWishlistCount();
      return;
    }

    // open flyout in wishlist-mode so size click adds to wishlist instead of cart
    resetFlyoutSelection(flyout);
    flyout.classList.add('is-wishlist-mode');
    flyout.setAttribute('data-wishlist-product-id', productId);
    // make sold-out sizes clickable in wishlist-mode — remove disabled, remember original state
    qsa('[data-select-variant]', flyout).forEach(b => {
      if (b.hasAttribute('disabled')) {
        b.setAttribute('data-was-disabled', '1');
        b.removeAttribute('disabled');
      }
    });
    openFlyout(flyout);
  });

  // Mark wishlist buttons + count on load
  function initWishlistUI() {
    qsa('[data-wishlist-toggle]').forEach(btn => {
      const id = btn.getAttribute('data-wishlist-toggle');
      if (wishlistHas(id)) btn.classList.add('is-active');
      else btn.classList.remove('is-active');
    });
    updateWishlistCount();
  }
  if (document.readyState !== 'loading') initWishlistUI();
  else document.addEventListener('DOMContentLoaded', initWishlistUI);

  // cross-tab sync
  window.addEventListener('storage', (e) => {
    if (e.key === WISHLIST_KEY) initWishlistUI();
  });

  /* ========== Modal ========== */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-modal-open]');
    if (open) {
      e.preventDefault();
      const modal = qs('[data-modal="' + open.getAttribute('data-modal-open') + '"]');
      if (modal) modal.classList.add('is-open');
      return;
    }
    const close = e.target.closest('[data-modal-close]');
    if (close) {
      const modal = close.closest('.modal');
      if (modal) modal.classList.remove('is-open');
    }
  });

  /* ========== Variant selection (product page) ========== */
  qsa('[data-size-selector]').forEach(container => {
    container.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-size-option]');
      if (!opt) return;
      const isSoldOut = opt.hasAttribute('disabled') || opt.getAttribute('data-sold-out') === '1';
      qsa('[data-size-option]', container).forEach(o => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');
      const variantId = opt.getAttribute('data-variant-id');
      const input = qs('[data-variant-input]');
      if (input && variantId) input.value = variantId;

      const atc = qs('[data-atc-button]');
      const waitlistWrap = qs('[data-waitlist-wrap]');

      if (isSoldOut) {
        if (atc) atc.hidden = true;
        if (waitlistWrap) {
          waitlistWrap.hidden = false;
          const wl = waitlistWrap.querySelector('[data-waitlist]');
          if (wl) {
            wl.setAttribute('data-waitlist-variant-id', variantId || '');
            wl.setAttribute('data-waitlist-size', (opt.textContent || '').trim().toLowerCase());
          }
          const form = waitlistWrap.querySelector('[data-waitlist-form]');
          if (form) {
            form.classList.remove('is-submitted');
            const btn = form.querySelector('.waitlist__btn');
            if (btn) { btn.disabled = false; btn.textContent = 'join the waitlist'; }
            const msg = form.querySelector('[data-waitlist-msg]');
            if (msg) msg.textContent = '';
          }
        }
      } else {
        if (waitlistWrap) waitlistWrap.hidden = true;
        if (atc) {
          atc.hidden = false;
          atc.disabled = false;
          const priceLabel = opt.getAttribute('data-variant-price');
          const label = atc.getAttribute('data-label-add') || 'add to bag';
          atc.textContent = priceLabel ? label + ' - ' + priceLabel : label;
        }
      }
    });
  });
})();

/* ============================================
   Product page — gallery slider
   ============================================ */
(function() {
  const qs  = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
    var slides = gallery.querySelectorAll('.product__slide');
    if (slides.length < 2) return;
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-current]');
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function(s, n) { s.classList.toggle('is-active', n === index); });
      if (counter) counter.textContent = index + 1;
    }
    if (prev) prev.addEventListener('click', function() { show(index - 1); });
    if (next) next.addEventListener('click', function() { show(index + 1); });

    // touch swipe (mobile)
    var startX = 0;
    gallery.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    });
  });

  /* ========== Template class on <body> ========== */
  /* helps target product pages in CSS/JS (e.g. hide-on-scroll) */
  (function () {
    var path = window.location.pathname || '';
    if (/\/products\//.test(path)) document.body.classList.add('template-product');
  })();

  /* ========== Product page: hide header on scroll down, reveal on scroll up ========== */
  (function () {
    if (!document.body.classList.contains('template-product')) return;
    var lastY = window.scrollY;
    var ticking = false;
    var threshold = 10;

    function onScroll() {
      var y = window.scrollY;
      if (Math.abs(y - lastY) < threshold) { ticking = false; return; }
      if (y > lastY && y > 80) {
        document.body.classList.add('header-hidden');
      } else {
        document.body.classList.remove('header-hidden');
      }
      /* also toggle header--scrolled for the transparent-to-solid background */
      var header = document.querySelector('.header');
      if (header) {
        if (y > 40) header.classList.add('header--scrolled');
        else header.classList.remove('header--scrolled');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  })();

  /* ========== Product page: colour picker ==========
     Clicking a colour thumbnail navigates to the matching variant so the
     gallery images reload. no-op if the button carries no variant id.   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-colour-option]');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var value = btn.getAttribute('data-value') || '';
    var label = qs('[data-colour-value]');
    if (label) label.textContent = value.toLowerCase();
    qsa('[data-colour-option]').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var url = new URL(window.location.href);
    url.searchParams.set('variant', vid);
    window.location.href = url.toString();
  });

  /* ========== Product page: inline size chart ==========
     Opens downward from the size-guide trigger. Mutually exclusive with
     the details / size-and-fit / shipping accordions.                    */
  function setSizeChartOpen(open) {
    var chart = qs('[data-product-size-chart]');
    var trigger = qs('[data-toggle-product-size-guide]');
    if (!chart) return;
    if (open) {
      chart.classList.add('is-open');
      chart.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      /* close every product-info accordion so only one panel is open */
      qsa('[data-accordion]').forEach(function (a) {
        a.classList.remove('is-open');
        var t = a.querySelector('[data-accordion-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    } else {
      chart.classList.remove('is-open');
      chart.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-toggle-product-size-guide]');
    if (!btn) return;
    e.preventDefault();
    var chart = qs('[data-product-size-chart]');
    if (!chart) return;
    setSizeChartOpen(!chart.classList.contains('is-open'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setSizeChartOpen(false);
  });

  /* ========== Product page: size-guide units toggle (inches / centimetres) ========== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-size-guide-units] [data-unit]');
    if (!btn) return;
    e.preventDefault();
    var group = btn.closest('[data-size-guide-units]');
    if (!group) return;
    qsa('[data-unit]', group).forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var unit = btn.getAttribute('data-unit') || 'cm';
    qsa('[data-size-table] td[data-cm]').forEach(function (td) {
      var v = td.getAttribute('data-' + unit);
      if (v) td.textContent = v;
    });
  });

  /* old right-drawer CTA removed — inline size chart has no separate CTA. */

  /* ========== Sync size selection across all size-selector instances ========== */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-size-option]');
    if (!opt || opt.hasAttribute('disabled')) return;
    var variantId = opt.getAttribute('data-variant-id');
    if (!variantId) return;
    qsa('[data-size-selector]').forEach(function (container) {
      qsa('[data-size-option]', container).forEach(function (o) {
        if (o.getAttribute('data-variant-id') === variantId) {
          o.classList.add('is-selected');
        } else {
          o.classList.remove('is-selected');
        }
      });
    });
  });

  /* ========== Buy the look: add outfit to bag (one-click multi-add) ========== */
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-add-all-ids]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var raw = btn.getAttribute('data-add-all-ids') || '';
    var ids = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n); });
    if (!ids.length) return;
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      });
      if (typeof refreshCart === 'function') await refreshCart();
      if (typeof openDrawer === 'function') openDrawer('cart');
    } catch (err) {} finally {
      btn.disabled = false;
    }
  });

  /* collection view toggle lives inline in sections/main-collection.liquid
     to guarantee fresh execution on every page load (safari caches this file
     aggressively). */
})();
